<script>
  import componentEditorMixin from '@/components/ProductComponents/CreateComponents/componentEditorMixin.js'
  export default {
    name: "crossThreeEditor",
    mixins: [componentEditorMixin],
    data() {
      return {
        directionList:[
          {
            value: '0',
            name: '0度'
          },
          {
            value: '90',
            name: '90度'
          },
          {
            value: '180',
            name: '180度'
          },
          {
            value: '270',
            name: '270度'
          },
        ],
        formList: [
          'CrossThreeForm',
        ],
        ruleList: {
        }
      }
    },
    mounted() {
      console.log("newSettings:",this.newSettings)
    },
    computed: {
      specificForms() {
        return (
          <div class="specificForms">
              <el-collapse-item class="specificForm" title="三通管道效果选项" name="2">
                <template slot="default">
                  <div class="specificForm">
                    <el-form id="CrossThreeForm" props={{model: this.newSettings}} ref="CrossThreeForm" rules={this.ruleList} label-style={this.formLabelStyle}
                             hide-required-asterisk={true}>
                      <el-form-item label="管道颜色" prop="background" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.background,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"管道颜色"
                          }}}{...{on: {
                            'input': val=>{
                              this.newSettings.background = val;
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="旋转角度" prop="direction" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.direction,
                          type: 'radio',
                          radioList: this.directionList,
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"旋转角度"
                          }}}{...{on: {
                            'input': val=>{
                              this.handleDirectionChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                    </el-form>
                  </div>
                </template>
              </el-collapse-item>
          </div>
        )
      }
    },
    methods:{
      handleDirectionChange(val) {
        if (val === "0" && (this.newSettings.direction == "90" || this.newSettings.direction == "270")) {
          //长宽对调
          let tempHeight = this.newSettings.width
          let tempWidth = this.newSettings.height
          this.handleUniversalChangeSize(tempWidth, 'width')
          this.handleUniversalChangeSize(tempHeight, 'height')
          this.newSettings.transform = 'rotate(0deg)'
        }else if(val === "0" && (this.newSettings.direction == "0" || this.newSettings.direction == "180")){
          this.newSettings.transform = 'rotate(0deg)'
        }else if (val === "90" && (this.newSettings.direction == "0" || this.newSettings.direction == "180")) {
          let tempHeight = this.newSettings.width
          let tempWidth = this.newSettings.height
          this.handleUniversalChangeSize(tempWidth, 'width')
          this.handleUniversalChangeSize(tempHeight, 'height')
          this.newSettings.transform = 'rotate(90deg)'
        }else if (val === "90" && (this.newSettings.direction == "90" || this.newSettings.direction == "270")) {
          this.newSettings.transform = 'rotate(90deg)'
        }else if (val === "180" && (this.newSettings.direction == "90" || this.newSettings.direction == "270")) {
          let tempHeight = this.newSettings.width
          let tempWidth = this.newSettings.height
          this.handleUniversalChangeSize(tempWidth, 'width')
          this.handleUniversalChangeSize(tempHeight, 'height')
          this.newSettings.transform = 'rotate(180deg)'
        }else if (val === "180" && (this.newSettings.direction == "0" || this.newSettings.direction == "180")) {
          this.newSettings.transform = 'rotate(180deg)'
        }else if(val === "270" && (this.newSettings.direction == "0" || this.newSettings.direction == "180")){
          let tempHeight = this.newSettings.width
          let tempWidth = this.newSettings.height
          this.handleUniversalChangeSize(tempWidth, 'width')
          this.handleUniversalChangeSize(tempHeight, 'height')
          this.newSettings.transform = 'rotate(270deg)'
        }else if(val === "270" && (this.newSettings.direction == "90" || this.newSettings.direction == "270")){
          this.newSettings.transform = 'rotate(270deg)'
        }

        this.newSettings.direction = val;
      },
    }
  }
</script>

<style lang="less" scoped>
</style>

